import { Row, Col, Button, Input, Select, Form, Spin, Tooltip } from "antd";
import styled from "@emotion/styled";
import Modal from "antd/lib/modal/Modal";

const { Option } = Select;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }
  .ant-modal-header {
    border-bottom: none;
    padding-top: 24px;
    border-radius: 12px 12px 0 0;
  }
  .ant-modal-title {
    font-weight: bold;
    font-size: 1.2rem;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-modal-footer {
    border-top: none;
    padding-bottom: 20px;
  }
  .ant-modal-content {
    min-width: 800px;
    min-height: 220px;
  }
  .ant-picker {
    width: 100%;
  }
`;

export const StyledFormInput = styled(Input)`
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  padding: 8px 12px;
  &:focus, &:hover {
    border-color: #52c6b0 !important;
    box-shadow: 0 0 0 2px rgba(82, 198, 176, 0.15) !important;
  }
`;

export const StyledFormSelect = styled(Select)`
  width: 100%;
  .ant-select-selector {
    border-radius: 6px !important;
    height: 40px !important;
    align-items: center;
    display: flex !important;
  }
  &.ant-select-focused .ant-select-selector,
  &:hover .ant-select-selector {
    border-color: #52c6b0 !important;
    box-shadow: 0 0 0 2px rgba(82, 198, 176, 0.15) !important;
  }
`;

export const CancelBtn = styled(Button)`
  border-radius: 6px;
  width: 100px;
  height: 38px;
  border-color: #000000;
`;

export const ActionBtn = styled(Button)`
  border-radius: 6px;
  width: 100px;
  height: 38px;
  background-color: #00685F;
  border-color: #00685F;
  color: #ffffff !important;
`;

const AccountModal = ({
  open, isEditMode, form, submitting,
  onCancel, onSubmit,
  accountTypeOptions, currencyOptions,
  editingBalance = 0,
  existingAccountNames = [],
  editingAccountName = null,
}) => {
  const currencyLocked = isEditMode && Number(editingBalance) !== 0;

  const duplicateNameValidator = (_, value) => {
    if (!value || !value.trim()) return Promise.resolve();
    const trimmed = value.trim().toLowerCase();
    if (isEditMode && editingAccountName && trimmed === editingAccountName.trim().toLowerCase()) {
      return Promise.resolve();
    }
    if (existingAccountNames.includes(trimmed)) {
      return Promise.reject(new Error("An account with this name already exists"));
    }
    return Promise.resolve();
  };
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (_) { }
  };

  const footer = [
    <CancelBtn key="cancel" onClick={onCancel} disabled={submitting}>Cancel</CancelBtn>,
    <ActionBtn key="submit" onClick={handleOk} loading={submitting}>
      {isEditMode ? "Update" : "Create"}
    </ActionBtn>,
  ];

  return (
    <StyledModal
      open={open}
      onCancel={onCancel}
      footer={footer}
      width={780}
      destroyOnClose
      title={isEditMode ? "Editing Account" : "Creating New Account"}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="accountName" label="Name of the Account"
              rules={[
                { required: true, message: "Account name is required" },
                { validator: duplicateNameValidator },
              ]}
              style={{ marginBottom: 16 }}>
              <StyledFormInput placeholder="Firm Account Mauritius" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="accountType" label="Account Type"
              rules={[{ required: true, message: "Account type is required" }]}
              style={{ marginBottom: 16 }}>
              <StyledFormSelect placeholder="Select type" disabled={currencyLocked}>
                {accountTypeOptions.map((t) => <Option key={t} value={t}>{t}</Option>)}
              </StyledFormSelect>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="accountNumber" label="Account Number" style={{ marginBottom: 16 }}>
              <StyledFormInput placeholder="748863799976467" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="accountHolderName" label="Account Holder Name" style={{ marginBottom: 16 }}>
              <StyledFormInput placeholder="John" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="branchName" label="Branch Name" style={{ marginBottom: 16 }}>
              <StyledFormInput placeholder="Mauritius" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="branchCode" label="Branch Code (If Applicable)" style={{ marginBottom: 16 }}>
              <StyledFormInput />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="currency" label="Currency"
              rules={[{ required: true, message: "Currency is required" }]}
              style={{ marginBottom: 16 }}>
              <StyledFormSelect placeholder="USD" showSearch optionFilterProp="children"
                disabled={currencyLocked}
              >
                {currencyOptions.map((c) => <Option key={c} value={c}>{c}</Option>)}
              </StyledFormSelect>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledModal>
  );
};

export default AccountModal;